export const getToken = async () => {
  const token = await localStorage.getItem("token");
  return token;
};
